import { Middleware } from 'redux'
import { isActionOf } from 'typesafe-actions'
import { ApiRequest } from '../../apiRequest'
import {
    getAiRecommendationsApiUrl,
    getAiRecommendationsTrackingApiUrl,
} from '../../../constants/apiUrls'
import {
    fetchAiRecommendationsForModel,
    fetchAiRecommendationsForModelAsync,
    setAiRecommendationsForModelData,
    trackAiRecommendedEquipments,
    trackAiRecommendedEquipmentsAsync,
} from '../../actions/app/aiRecommendation.actions'

const aiRecommendationsMiddleware =
    (apiRequest: ApiRequest): Middleware => (store) => (next) => (action) => {
        next(action)
        const {dispatch} = store

        if (isActionOf(fetchAiRecommendationsForModel, action)) {
            apiRequest({
                options: {
                    url: getAiRecommendationsApiUrl(),
                    method: 'GET',
                },
                asyncActions: fetchAiRecommendationsForModelAsync,
                causedBy: action,
            }, dispatch)
        }

        if (isActionOf(trackAiRecommendedEquipments, action)) {
            const recommendationTrackingData = action.payload

            apiRequest({
                options: {
                    url: getAiRecommendationsTrackingApiUrl(),
                    method: 'POST',
                    body: JSON.stringify(recommendationTrackingData),
                },
                asyncActions: trackAiRecommendedEquipmentsAsync,
                causedBy: action,
            }, dispatch)
        }

        if (isActionOf(fetchAiRecommendationsForModelAsync.success, action)) {
            const recommendationsForModelData = action.payload

            dispatch(setAiRecommendationsForModelData(recommendationsForModelData))
        }
    }

export default aiRecommendationsMiddleware
